import { XMarkIcon } from "@heroicons/react/24/outline";
import useCartItem from "../hooks/useCartItem";
import { QuantityStepper } from "./ui";

// price / oldPrice — актуальні ціни з серверного розрахунку кошика (якщо вже прийшли)
const CartItem = ({ item, price, oldPrice }) => {
  // У кошику «−» не прибирає товар з 1 шт. — для цього є хрестик
  const cart = useCartItem(item, { removeAtZero: false });
  const shownPrice = price ?? item.price;
  const shownOldPrice = price != null ? oldPrice : item.old_price;

  return (
    <div className="flex gap-4 p-4 rounded-2xl bg-slate-900/80 border border-slate-700">
      <div className="w-20 h-20 rounded-2xl overflow-hidden bg-slate-800 shrink-0">
        <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
      </div>

      <div className="flex flex-col flex-1 justify-between min-w-0">
        <div className="flex justify-between items-start gap-2">
          <div className="min-w-0">
            <h3 className="font-semibold text-slate-100 leading-snug">{item.name}</h3>
            {item.flavor && <p className="text-xs text-slate-400">Вкус: {item.flavor}</p>}
          </div>

          <button
            aria-label="Удалить из корзины"
            onClick={cart.remove}
            className="shrink-0 w-8 h-8 -mr-1 -mt-1 rounded-full flex items-center justify-center text-slate-400 hover:text-red-400 hover:bg-red-500/10 transition"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>

        <div className="flex justify-between items-end mt-2 gap-2">
          <span className="font-bold text-blue-400">
            {shownPrice} zł
            {shownOldPrice && (
              <span className="ml-2 text-xs font-normal text-slate-500 line-through">
                {shownOldPrice} zł
              </span>
            )}
          </span>

          <QuantityStepper
            size="sm"
            quantity={cart.quantity}
            onDecrease={cart.decrease}
            onIncrease={cart.increase}
          />
        </div>
      </div>
    </div>
  );
};

export default CartItem;
